export function formatTime(dateString) {
  //console.log(dateString);
  if (!dateString) return "";
  const date = new Date(dateString);
  return date.toLocaleString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });
}

export function getCompactTimeDifference(start, end) {
  const startTime = new Date(start);
  const endTime = new Date(end);
  const diffMs = endTime - startTime;

  const totalSeconds = Math.floor(diffMs / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  let result = "";
  if (hours) result += `${hours} hour${hours !== 1 ? "s" : ""}, `;
  if (minutes) result += `${minutes} minute${minutes !== 1 ? "s" : ""}, `;
  if (seconds || (!hours && !minutes))
    result += `${seconds} second${seconds !== 1 ? "s" : ""}`;

  return result.trim().replace(/,\s*$/, ""); // removes trailing comma if needed
}
